/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TemplateV2ExecuteRequest extends models.TemplateExecutionRequestBase {
    getFixupPrototypeFunction() { return TemplateV2ExecuteRequest.fixupPrototype; }

    static newInstance(model: Partial<TemplateV2ExecuteRequest>): TemplateV2ExecuteRequest {
        let obj = Object.assign(new TemplateV2ExecuteRequest(), model);
        TemplateV2ExecuteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TemplateV2ExecuteRequest>): TemplateV2ExecuteRequest {
        if (!model) return null;
        return TemplateV2ExecuteRequest.newInstance(<TemplateV2ExecuteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TemplateV2ExecuteRequest) {
        if (!obj) return;

        models.TemplateV2ExecuteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TemplateV2ExecuteRequest): boolean {
        if (models.TemplateExecutionRequestBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, TemplateV2ExecuteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.incident_reference) {
            models.TemplateIncidentReference.fixupPrototype(this.incident_reference);
        }
    }

    /**
     * Incident reference, if this execution is tied to an ITSM incident
     */
    incident_reference: models.TemplateIncidentReference;

    /**
     * ID of a Terraform plan that a prior Plan call generated. When set, Execute applies that exact plan instead of re-planning at execution time; omit it to plan and apply fresh. Terraform templates only.
     */
    plan_reference_id: string;

}
